import React from 'react';

const Dashboard = React.lazy(() => import('./Dashboard'));

export const dashboardRouteConfigs = [
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
];
